// extracted by mini-css-extract-plugin
export default {"wrapper":"ColumnHeadBar_wrapper__hclGb","title":"ColumnHeadBar_title__h0bFl","btn":"ColumnHeadBar_btn__otIht","btnIcon":"ColumnHeadBar_btnIcon__xsQZR"};